// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"59446f7b","190":"11b763f7"}[chunkId] + ".chunk.js";
};